export const shouldMock = process.env.NEXT_PUBLIC_MOCK === 'true';
